import { useQuery } from '@tanstack/react-query';
import { minutesToMilliseconds } from 'date-fns';

import meKeys from '@/api/queries/me/keyFactory';
import { graphql } from '@/gql';
import { gqlClient } from '../../graphql-client';

export const GetMe = graphql(`
  query GetMe {
    me {
      permissions
      emailSignature
      hasChatAgentAccess
      preferences {
        useNewDashboard
        collapsedScheduleGroupIds
      }
      emailSenderChoice {
        ...SenderChoiceField_EmailSenderChoice
      }
      user {
        id
        publicId
        firstName
        fullName
        isPrimaryUser
        systemRole
        phone
        account {
          id
          name
          phone
          email
          enforceSSO
          sendProposalEmailBody
          activeSubscription {
            id
            tier
          }
          analytics {
            embeddableDashboards {
              title
              uniqueIdentifier
              embedUrl
            }
          }
        }
        originalAccountId
        costPerHour {
          value
          currency {
            id
            code
            exponent
          }
        }
      }
      integrations {
        google {
          isActive
          email
        }
      }
    }
  }
`);

const useGetMe = () => {
  const { data, ...rest } = useQuery({
    queryKey: meKeys.all,
    queryFn: async () => gqlClient.request(GetMe),
    staleTime: minutesToMilliseconds(5),
  });
  return {
    data: data?.me,
    user: data?.me?.user,
    analytics: data?.me?.user?.account?.analytics,
    hasChatAgentAccess: data?.me?.hasChatAgentAccess ?? false,
    preferences: data?.me?.preferences,
    permissions: data?.me?.permissions,
    ...rest,
  };
};

export default useGetMe;
